import { EventEmitter } from '@angular/core';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { faPen } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoService } from '@jsverse/transloco';
import { Map } from 'maplibre-gl';

import { AbstractMapControl } from '@connect-services/client/components/map/abstract-map-control';
import { MapEditModeService } from '@connect-services/client/services/map-edit-mode.service';
import { ProjectEditModeService } from '@connect-services/client/services/project-edit-mode.service';

export class EditModeControl extends AbstractMapControl {
    public editModeToggled: EventEmitter<boolean> = new EventEmitter<boolean>();

    public constructor(
        map: Map,
        private readonly mapEditModeService: MapEditModeService,
        private readonly projectEditModeService: ProjectEditModeService,
        private readonly translocoService: TranslocoService,
    ) {
        super(projectEditModeService.button);
        this.map = map;

        this.mapEditModeService.registerEditModeChangeListener((state) => {
            this.setButtonState({
                isActive: state,
            });
        });
    }

    protected initButton(): void {
        this.setupButton('map-edit-mode-control', () => this.toggleEditMode(), ['map-edit-mode-control']);
        this.refreshButton();
    }

    protected override setButtonIcon(): void {
        this.button.innerHTML = icon(faPen).html[0];
    }

    private refreshButton(): void {
        this.setButtonIcon();

        this.setButtonState({
            isActive: this.mapEditModeService.isMapEditModeActive(),
        });

        this.setButtonTitle(this.translocoService.translate('editMode.editMode'));
    }

    private async toggleEditMode(): Promise<void> {
        if (!this.map) {
            return;
        }

        await this.mapEditModeService.requestToggleEditMode();

        const isActive = this.mapEditModeService.isMapEditModeActive();
        this.editModeToggled.emit(isActive);
    }
}
